
import { supabase } from "../../../../supabaseClient";
import React, { useEffect, useState } from "react";
import "./Statistics.css";

const GA_PROPERTY_ID = "479863820";
const API_KEY = "AIzaSyAiHy39uQ0IxBmszp99obzmuxdXE7lt_hE";


const Statistics = () => {
    const [stats, setStats] = useState({
        visitors: "Laddar...",
        bestallningar: "-",
        conversionRate: "-",
        checkoutConversion: "-",
        abandoned: "-",
    });

    const [period, setPeriod] = useState("7days");

    const getStartDate = (range) => {
        switch (range) {
            case "30days":
                return "30daysAgo";
            case "90days":
                return "90daysAgo";
            default:
                return "7daysAgo";
        }
    };

    useEffect(() => {
        const loadGapi = () => {
            if (!window.gapi) {
                const script = document.createElement("script");
                script.src = "https://apis.google.com/js/api.js";
                script.onload = initGapi;
                document.body.appendChild(script);
            } else {
                initGapi();
            }
        };

        const initGapi = () => {
            window.gapi.load("client", async () => {
                try {
                    await window.gapi.client.init({
                        apiKey: API_KEY,
                        discoveryDocs: ["https://analyticsdata.googleapis.com/$discovery/rest?version=v1beta"],
                    });
                    console.log("✅ GAPI client initialized");
                    fetchStatsForVisitors();
                    fetchStatsForPurchases();
                } catch (err) {
                    console.error("❌ Error initializing GAPI:", err);
                }
            });
        };

        loadGapi();
    }, [period]);

    const fetchStatsForVisitors = async () => {
        try {
            const response = await window.gapi.client.analyticsdata.properties.runReport({
                property: `properties/${GA_PROPERTY_ID}`,
                dateRanges: [
                    {
                        startDate: getStartDate(period),
                        endDate: "today",
                    },
                ],
                metrics: [{ name: "activeUsers" }],
            });

            console.log("📊 GA4 Data API response:", response);

            const rows = response?.result?.rows;
            const visitors = rows?.[0]?.metricValues?.[0]?.value || "0";

            setStats((prev) => ({
                ...prev,
                visitors,
            }));
        } catch (err) {
            console.error("❌ Error fetching GA4 data:", err);
            setStats((prev) => ({
                ...prev,
                visitors: "Fel",
            }));
        }

    };

    const fetchStatsForPurchases = async () => {
        try {
            const {count, error} = await supabase.from("orders").select("*", {count: 'exact', head: true});

            if(error) throw error;
            {console.log(error)}

            setStats((prev) =>({
                ...prev,
                purchases: count,
            }));

        } catch (err) {
            console.error("❌ Error fetching purchases:", err);

        }
    }

    return (
        <div className="statistics-container">
            <div className="time-filter">
                <label htmlFor="time-select">Välj tidsperiod:</label>
                <select id="time-select" value={period} onChange={(e) => setPeriod(e.target.value)}>
                    <option value="7days">Senaste 7 dagarna</option>
                    <option value="30days">Senaste 30 dagarna</option>
                    <option value="90days">Senaste 90 dagarna</option>
                </select>
            </div>

            <h2>Statistik</h2>
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Besökare</h3>
                    <p className="stat-value">{stats.visitors}</p>
                </div>
                <div className="stat-card">
                    <h3>Beställningar</h3>
                    <p className="stat-value">{stats.purchases}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering</h3>
                    <p className="stat-value">{stats.conversionRate}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering i kassan</h3>
                    <p className="stat-value">{stats.checkoutConversion}</p>
                </div>
                <div className="stat-card">
                    <h3>Avbrutna beställningar</h3>
                    <p className="stat-value">{stats.abandoned}</p>
                </div>
            </div>
        </div>
    );
};

export default Statistics;

/*Abdullah latest push with google analytics login*/
/*import React, {useEffect, useState} from "react";
import {initializeGapiClient, getAccessToken} from "../../../Utils/gapi";
import "./Statistics.css";

const CLIENT_ID = "677453810530-84rhhhk8bu4fqrdmg5ds6coimnnbkor6.apps.googleusercontent.com"; // OAuth client ID
const GA4_PROPERTY_ID = "479863820";

const Statistics = () => {
    const [stats, setStats] = useState({
        visitors: "Laddar...",
        purchases: "-",
        conversionRate: "-",
        checkoutConversion: "-",
        abandoned: "-",
    });

    const [period, setPeriod] = useState("7days");

    const getStartDate = (range) => {
        switch (range) {
            case "30days":
                return "30daysAgo";
            case "90days":
                return "90daysAgo";
            default:
                return "7daysAgo";
        }
    };

    useEffect(() => {
        const loadAndFetch = async () => {
            try {
                await initializeGapiClient();
                const token = await getAccessToken(CLIENT_ID);
                window.gapi.client.setToken({access_token: token});

                const res = await window.gapi.client.analyticsdata.properties.runReport({
                    property: GA4_PROPERTY_ID,
                    dateRanges: [{startDate: getStartDate(period), endDate: "today"}],
                    metrics: [{name: "activeUsers"}],
                });

                const visitors = res.result?.rows?.[0]?.metricValues?.[0]?.value || "0";

                setStats((prev) => ({...prev, visitors}));
            } catch (err) {
                console.error("❌ GA Fetch Failed:", err);
                setStats((prev) => ({...prev, visitors: "Fel"}));
            }
        };

        loadAndFetch();
    }, [period]);

    return (
        <div className="statistics-container">
            <div className="time-filter">
                <label htmlFor="time-select">Välj tidsperiod:</label>
                <select id="time-select" value={period} onChange={(e) => setPeriod(e.target.value)}>
                    <option value="7days">Senaste 7 dagarna</option>
                    <option value="30days">Senaste 30 dagarna</option>
                    <option value="90days">Senaste 90 dagarna</option>
                </select>
            </div>

            <h2>Statistik</h2>
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Besökare</h3>
                    <p className="stat-value">{stats.visitors}</p>
                </div>
                <div className="stat-card">
                    <h3>Beställningar</h3>
                    <p className="stat-value">{stats.purchases}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering</h3>
                    <p className="stat-value">{stats.conversionRate}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering i kassan</h3>
                    <p className="stat-value">{stats.checkoutConversion}</p>
                </div>
                <div className="stat-card">
                    <h3>Avbrutna beställningar</h3>
                    <p className="stat-value">{stats.abandoned}</p>
                </div>
            </div>
        </div>
    );
};

export default Statistics;*/



/*Abadullah previous push without google analytics login   */
/*import React, {useEffect, useState} from "react";
import "./Statistics.css";

const GA_PROPERTY_ID = "479863820";
const API_KEY = "AIzaSyAiHy39uQ0IxBmszp99obzmuxdXE7lt_hE";


const Statistics = () => {
    const [stats, setStats] = useState({
        visitors: "Laddar...",
        bestallningar: "-",
        conversionRate: "-",
        checkoutConversion: "-",
        abandoned: "-",
    });

    const [period, setPeriod] = useState("7days");

    const getStartDate = (range) => {
        switch (range) {
            case "30days":
                return "30daysAgo";
            case "90days":
                return "90daysAgo";
            default:
                return "7daysAgo";
        }
    };

    useEffect(() => {
        const loadGapi = () => {
            if (!window.gapi) {
                const script = document.createElement("script");
                script.src = "https://apis.google.com/js/api.js";
                script.onload = initGapi;
                document.body.appendChild(script);
            } else {
                initGapi();
            }
        };

        const initGapi = () => {
            window.gapi.load("client", async () => {
                try {
                    await window.gapi.client.init({
                        apiKey: API_KEY,
                        discoveryDocs: ["https://analyticsdata.googleapis.com/$discovery/rest?version=v1beta"],
                    });
                    console.log("✅ GAPI client initialized");
                    fetchStatsForVisitors();
                    fetchStatsForPurchases();
                } catch (err) {
                    console.error("❌ Error initializing GAPI:", err);
                }
            });
        };

        loadGapi();
    }, [period]);

    const fetchStatsForVisitors = async () => {
        try {
            const response = await window.gapi.client.analyticsdata.properties.runReport({
                property: `properties/${GA_PROPERTY_ID}`,
                dateRanges: [
                    {
                        startDate: getStartDate(period),
                        endDate: "today",
                    },
                ],
                metrics: [{ name: "activeUsers" }],
            });

            console.log("📊 GA4 Data API response:", response);

            const rows = response?.result?.rows;
            const visitors = rows?.[0]?.metricValues?.[0]?.value || "0";

            setStats((prev) => ({
                ...prev,
                visitors,
            }));
        } catch (err) {
            console.error("❌ Error fetching GA4 data:", err);
            setStats((prev) => ({
                ...prev,
                visitors: "Fel",
            }));
        }

    };

    const fetchStatsForPurchases = async () => {
        try {
            const {count, error} = await supabase.from("orders").select("*", {count: 'exact', head: true});

            if(error) throw error;
            {console.log(error)}

            setStats((prev) =>({
                ...prev,
                purchases: count,
            }));

        } catch (err) {
            console.error("❌ Error fetching purchases:", err);

        }
    }

    return (
        <div className="statistics-container">
            <div className="time-filter">
                <label htmlFor="time-select">Välj tidsperiod:</label>
                <select id="time-select" value={period} onChange={(e) => setPeriod(e.target.value)}>
                    <option value="7days">Senaste 7 dagarna</option>
                    <option value="30days">Senaste 30 dagarna</option>
                    <option value="90days">Senaste 90 dagarna</option>
                </select>
            </div>

            <h2>Statistik</h2>
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Besökare</h3>
                    <p className="stat-value">{stats.visitors}</p>
                </div>
                <div className="stat-card">
                    <h3>Beställningar</h3>
                    <p className="stat-value">{stats.purchases}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering</h3>
                    <p className="stat-value">{stats.conversionRate}</p>
                </div>
                <div className="stat-card">
                    <h3>Konvertering i kassan</h3>
                    <p className="stat-value">{stats.checkoutConversion}</p>
                </div>
                <div className="stat-card">
                    <h3>Avbrutna beställningar</h3>
                    <p className="stat-value">{stats.abandoned}</p>
                </div>
            </div>
        </div>
    );
};

export default Statistics;*/